import React from "react"

import globalStyles from "../../../../App.module.scss"
import {Prism as SyntaxHighlighter} from "react-syntax-highlighter"
import {dracula} from "react-syntax-highlighter/dist/cjs/styles/prism"

let preambleExample = `#!/usr/bin/env bash
set -euo pipefail
IFS=$'\\n\\t'

# -e          exit on any command failure
# -u          error on unset variables
# -o pipefail a pipeline fails if any stage fails
# IFS         avoid surprises from word-splitting on spaces`

let debugExample = `# Trace every command before it runs
set -x
cp "$src" "$dst"
set +x

# Or trace a single invocation without editing the script
bash -x ./deploy.sh

# Prefix trace output with function name and line number
PS4='+$\{BASH_SOURCE}:$\{LINENO}:$\{FUNCNAME[0]:-main}: '`

export default function StrictModeDebugging() {
    return (
        <div className={globalStyles.article}>
            <h1>Strict mode & debugging</h1>

            <h3>The "strict mode" preamble</h3>
            <p>A common defensive header for scripts that should fail loudly instead of limping along after an
                error.</p>
            <SyntaxHighlighter
                children={preambleExample}
                style={dracula}
                PreTag="div"
                language={'bash'}
            />
            <p>Caveat: <code>set -e</code> has well-known edge cases — it doesn't trigger inside
                <code> if</code>/<code>&&</code>/<code>||</code> conditions, or for the non-last command in a
                pipeline (unless <code>pipefail</code> is also set). Don't treat it as a substitute for actual
                error handling on commands you know can fail.</p>

            <h3>Tracing execution</h3>
            <SyntaxHighlighter
                children={debugExample}
                style={dracula}
                PreTag="div"
                language={'bash'}
            />

            <h3>Other useful checks</h3>
            <div className={globalStyles.styledTable}>
                <table style={{minWidth: '450px'}}>
                    <thead>
                    <tr>
                        <th>Command</th>
                        <th>Purpose</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><code>bash -n script.sh</code></td>
                        <td>Syntax check only — doesn't execute anything</td>
                    </tr>
                    <tr>
                        <td><code>shellcheck script.sh</code></td>
                        <td>Static analysis — catches quoting bugs, unused vars, portability issues</td>
                    </tr>
                    <tr>
                        <td><code>set -v</code></td>
                        <td>Print each line as read, before expansion (vs. <code>-x</code> which prints after)</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    )
}
